/* import __COLOCATED_TEMPLATE__ from './badge-segmented-content.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();